// Sidebar del rol Directivo — estructura del rediseño 2026-07 (mockups D5):
// grupos Operación / Análisis / Gobierno, items de texto SIN íconos (fiel al
// mockup, a diferencia de los sidebars de coordinador/supervisor).
//
// Solo lista pantallas que EXISTEN (regla F6: cero promesas muertas).
//
// "Plantas" apunta al drill de análisis existente (/coordinador, que ya se
// adapta al rol directivo en solo lectura); lo reemplaza la página Planta
// propia del mundo directivo cuando exista (brief §4.2).

import { Sidebar, SidebarGroup, SidebarItem } from './SidebarNav';
import { useMe } from '../../lib/api/queries';
import { useAuth } from '../../lib/auth';
import { VerComoLanzador } from '../../features/directivo/ver-como/VerComoLanzador';

export function DirectivoSidebar() {
  const me = useMe();
  const { state } = useAuth();
  const tenantNombre =
    state.kind === 'signed_in'
      ? (state.claims.tenants_disponibles.find((t) => t.id === state.claims.tenant_id_activo)
          ?.nombre ?? '')
      : '';
  const puedeConfigurar = me.data?.ctx.puede_configurar_tenant ?? false;
  // La pestaña de plata solo existe con la capacidad (brief: el layout no
  // queda cojo — el grupo Finanzas entero desaparece).
  const puedeVerCostos = me.data?.ctx.puede_ver_costos ?? false;

  return (
    <Sidebar>
      {/* Poda 2026-07-05 (auditoría + decisión del responsable): fuera
          Plantas (mundo coordinador con voseo y CTAs), Análisis mensual y
          Clientes (look viejo, duplican el Dashboard con formatos rotos).
          Las RUTAS siguen vivas por URL directa; vuelven al menú si se
          rediseñan. Resumen semanal VOLVIÓ el mismo día: formatos es-CO,
          guard del eje y descarga del informe ejecutivo para junta. */}
      <SidebarGroup label="Operación">
        <SidebarItem to="/directivo" end>
          Dashboard
        </SidebarItem>
        <SidebarItem to="/directivo/lineas">Líneas de producción</SidebarItem>
        {/* Módulo Mantenimiento (fusión CMMS): visible solo con la capability
            — el gate duro es el API. */}
        {(me.data?.ctx.puede_ver_mantenimiento ?? false) ? (
          <SidebarItem to="/mantenimiento">Mantenimiento</SidebarItem>
        ) : null}
        {/* Pantalla de planta (P1): el directivo la ve con su propia sesión —
            el rol `pantalla` NO es suplantable por "Ver como" y no hace falta,
            su scope está contenido en el del directivo. */}
        <SidebarItem to="/pantalla">Pantalla de planta</SidebarItem>
      </SidebarGroup>
      <SidebarGroup label="Análisis">
        <SidebarItem to="/directivo/semanal">Resumen semanal</SidebarItem>
        <SidebarItem to="/directivo/personal">Personal</SidebarItem>
      </SidebarGroup>
      {puedeVerCostos ? (
        <SidebarGroup label="Finanzas">
          <SidebarItem to="/directivo/facturacion">Facturación</SidebarItem>
        </SidebarGroup>
      ) : null}
      <SidebarGroup label="Gobierno">
        <SidebarItem to="/directivo/auditoria">Auditoría</SidebarItem>
        {puedeConfigurar ? <SidebarItem to="/admin">Configuración</SidebarItem> : null}
      </SidebarGroup>
      {/* Modo espejo de solo lectura: revisar la vista de un coordinador o del
          módulo de mantenimiento sin poder editar. */}
      <div className="mt-4 border-t border-border pt-3">
        <VerComoLanzador />
      </div>
      <div className="mt-auto px-3 pb-1 pt-4">
        <p className="truncate font-mono text-[10px] tracking-[0.06em] text-fg-tertiary">
          Jidokap{tenantNombre ? ` · ${tenantNombre}` : ''}
        </p>
      </div>
    </Sidebar>
  );
}
